/**
 * PATH: apps/hr/src/pages/leave/components/StatCards.tsx
 * PURPOSE: Stat card component for the Leave & Attendance page header
 */

import { cn } from '../../../lib/utils'

export function StatCard({ label, value, icon: Icon, color, subtext }: {
  label: string
  value: number | string
  icon: React.ElementType
  color: string
  subtext?: string
}) {
  return (
    <div className="bg-white dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-800 p-4">
      <div className="flex items-center gap-3">
        <div className={cn('w-10 h-10 rounded-xl flex items-center justify-center', color)}>
          <Icon className="w-5 h-5" />
        </div>
        <div>
          <p className="text-2xl font-semibold text-slate-900 dark:text-white">{value}</p>
          <p className="text-sm text-slate-500">{label}</p>
          {subtext && <p className="text-xs text-slate-400">{subtext}</p>}
        </div>
      </div>
    </div>
  )
}
